<template>
    <div class="wecoupon-mall-title">
        <div class="title">{{ $props.title }}</div>
        <div class="my-coupons" @click="handleClick">{{ i18n('已領優惠券') }}</div>
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue-demi';
import { i18n } from '../../../i18n';
import { windowHelper } from '@tencent/ppd-base-libs';
import { getCurBusinessName } from '../../../components/activity-module/hook';

export default defineComponent({
  name: 'MallTitle',
  props: {
    title: {
      type: String,
      required: true,
    },
  },
  setup(props, context) {
    function handleClick() {
      const bizName = getCurBusinessName();
      windowHelper.redirect(`//prom.wechatpay.com.hk/discount-center/coupon_home.shtml?ADTAG=${bizName}_wecoupons_mall&page=displaycouponlist`, 300);
    }

    return {
      i18n,
      handleClick,
    };
  },
});
</script>

<style lang="less" scoped>
@import (reference) '../../../less/main.less';

.wecoupon-mall-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 20 / @rem;

    .title {
        font-family: 'PingFangHK-Medium', system-ui, -apple-system, BlinkMacSystemFont, '.SFNSText-Regular', sans-serif;
        font-size: 32 / @rem;
        line-height: 48 / @rem;
    }

    .my-coupons {
        color: #808080;
        font-size: 24/ @rem;
        line-height: 32/ @rem;

        &::after {
            content: ' ';
            display: inline-block;
            background-image: url(../assets/arrow-right.png);
            width: 10.578 /@rem;
            height: 18 /@rem;
            background-size: 100%;
            background-repeat: no-repeat;
            margin-left: 8 /@rem;
        }
    }
}
</style>

